import React, { Component } from "react";

import LandingPage from "./LandingPage/LandingPage";
import InitialForm from "./InitialForm/InitialForm";
import '../assets/styles/style.css';
import apiService from "./Services/APIService";
import HWUser from "./HWLibrary/HWUser";
import 'react-block-ui/style.css'; 
import xmppService from './Services/XMPPService';
import HWLog from "./HWLibrary/HWLog";
import ConversationPage from "./Conversation/ConversationPage";
import StartUp from "./StartUp";
import { s360ConfigService } from "./Services/S360Config";
import ActivityIndicator from "./CommonUtils/ActivityIndicator";
// import ErrorMessagePage from "./CommonUtils/ErrorMessagePage";
import PopUpMessage from "./CommonUtils/PopUpMessage";
import { sendOnAppOpen, sendOnAppClose } from "./Services/HWIframeBridge";
class Simplify360Chat extends Component {

    constructor(props) {
        super(props);
        //const isLoggedIn = HWUser.isLoggedIn();
        const isLoggedIn = true;
        HWLog.info("Is Logged In: "+ isLoggedIn);
        // console.log(s360ConfigService.isClientHostConfigured());
        // console.log(s360ConfigService.isConfigured());
        // console.log(s360ConfigService);
        const showForm   = s360ConfigService.config.configDetails && s360ConfigService.config.configDetails.showForm;
        const firstPage  = !isLoggedIn && showForm ? Simplify360Chat.pageName.initialForm : Simplify360Chat.pageName.landingPage;
        let showActivityIndicator = isLoggedIn ? false: !(!isLoggedIn && showForm);
        this.state       = { visiblePage: firstPage , isAppOpen: false , showForm: showForm, showPopUpMessage: false, showActivityIndicator: showActivityIndicator }; 
        this.state = {isAppOpen :true}
    }

    static pageName = {         // enum
        initialForm:      'initialForm', 
        landingPage:      'landingPage', 
        conversationPage: 'conversationPage',
    };      

    render() {
        HWLog.info("MAIN PAGE RENDER");
        // TODO: Auto log in if showForm is false. Find out what is needed in input parameters for auto login.
        // let isLoggedIn = HWUser.isLoggedIn();
        let isLoggedIn = true;
        return (  
            <>
            {(<StartUp actions={this.actions} />)}
            {this.state.isAppOpen && (
            <div className="s360-main-float-container" style={this.containerStyle()} >
                { this.state.visiblePage === Simplify360Chat.pageName.initialForm       && (<InitialForm        key={"inital-form-" + isLoggedIn}       config={s360ConfigService.config} actions={this.actions} {...this.state} />) }
                { this.state.visiblePage === Simplify360Chat.pageName.landingPage       && (<LandingPage        key={"landing-page-" + isLoggedIn}      config={s360ConfigService.config} actions={this.actions} {...this.state} />) } 
                { this.state.visiblePage === Simplify360Chat.pageName.conversationPage  && (<ConversationPage   key={"conversation-page-" + isLoggedIn} config={s360ConfigService.config} actions={this.actions} {...this.state} />) } 
                { this.state.showActivityIndicator && (<ActivityIndicator config={s360ConfigService.config} actions={this.actions} {...this.state} />) } 
                { this.state.showPopUpMessage      && <PopUpMessage popUpMessage={this.state.popUpMessage}  onClose={() => { this.setState({ showPopUpMessage: false, popUpMessage: null }) }} /> }
            </div>
            )}
            </>
        )
    }

    componentDidMount() {
        if (this.state.isAppOpen) {
            this.checkAndAutoLogin();
        }
    }
//listen for message from iframe (Simplify360Chat())
//on message perform buttonLaunch flow

    actions = {
        startChat: (formDetails)     => { this.login(formDetails);          },
        startConversation: (details, completionHandler) => { this.startConversation(details, completionHandler);  },
        showLandingScreen: ()        => { this.moveToPage(Simplify360Chat.pageName.landingPage); },
        onStartUpClick:   ()         => { this.onStartUpClick(); },
        markActiveConversationAsClosed: () => { this.markActiveConversationAsClosed(); },
        onHideChatWindow: ()         => { this.setState({ isAppOpen: false })},
        showPopUpMessage: (message)  => { this.showPopUpMessage(message); }
    }

    checkAndAutoLogin = () => {
        //if buttonLaunc is there in config dont login here
        //instead go toa function and continue the flow from there
        //flow : -
        //login and open chat
        //after login call chat api
        //next time same function is called 
        //send required API
        s360ConfigService.loadClientConfigFromToken();
        if(!HWUser.isLoggedIn() && s360ConfigService.config.configDetails && s360ConfigService.config.configDetails.showForm === false && this.state.isAppOpen) {
            // Auto Login
            let configFormDetails = {...s360ConfigService.s360UserConfig};
            this.login(configFormDetails);
            // console.log(configFormDetails);
            // alert("AUTO LOGIN");
        }
    }

    onStartUpClick = () => {
        let updatedState = !this.state.isAppOpen;
        if (updatedState) { sendOnAppOpen(); }
        else { sendOnAppClose(); }

        this.setState({ isAppOpen: updatedState }, () => {
            this.checkAndAutoLogin();
        }); 
    }

    login = (formDetails) => {
       
        // console.log("FormDetails: ", formDetails)
        return apiService.logInWithFormData(formDetails).then(loginResult => {

            HWLog.info("LOGIN Result: ", loginResult.data);
            if (!loginResult.data || loginResult.data.error) {
                this.setState({errorMessage: loginResult.data.error || ''}, () => {
                    this.showPopUpMessage(loginResult.data.error || 'Something went worng. Please try again.');
                });
            } else {
              HWUser.updateUserDetails(loginResult.data);
              this.setState({ showActivityIndicator: false }, () => {
                this.moveToPage(Simplify360Chat.pageName.landingPage); // XMPP connection is handled on landing screen.
              })
            }
        }).catch(this.onAPIError)
    }

    markActiveConversationAsClosed = () => {
       if (this.state.activeConversation) {
           let activeConversation    = this.state.activeConversation;
           activeConversation.active = false;
           HWLog.info("MARKED ACTIVE CONVERSATION AS CLOSED:");
           this.setState({ activeConversation: activeConversation });
       }
    }

    showPopUpMessage = (message) => {
        if (!message) { return }
        this.setState({ showPopUpMessage: true, popUpMessage: message, showActivityIndicator: false });
    }

    // Moves to existing conversation.
    startConversation = (conversationDetials, completionHandler) => {
        this.setState({activeConversation: conversationDetials}, () => {
            this.moveToPage(Simplify360Chat.pageName.conversationPage, completionHandler);
        });
    }

    moveToPage = (pageName, onStateUpdate) => {
        this.setState({visiblePage: pageName}, () => {  onStateUpdate && onStateUpdate(); });
    }

    configureAndConnectToXMPP = (xmpppConfig) => {
        xmppService.configure(xmpppConfig).catch(this.onAPIError)
    }

    onAPIError = (error) => {
        let messageToShow = (error && error.message === "Network Error") ?  "Please check your internet connectivity.": "Could not connect to server, please try again.";    
        HWLog.error(error, messageToShow);
        this.showPopUpMessage(messageToShow);
        // alert("Could not connect to the server. Please try again.");
    }

    containerStyle = () => {
        return {
            // background: s360ConfigService.config.designDetails.headerBackgroundImage !== undefined && s360ConfigService.config.designDetails.headerBackgroundImage !== ""?("url("+s360ConfigService.config.designDetails.headerBackgroundImage+")"):s360ConfigService.config.designDetails.headerColor,
            // borderColor: s360ConfigService.config.designDetails.headerColor,
            borderStyle: "solid",
            borderWidth: "0.5px",
            borderRadius: "24px",
            // height:"640px",
            // width:"360px"
        }
    }

}

export default Simplify360Chat;